
import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";

interface QuestionTimerProps {
  timeLimit?: number | null;
  onTimeUp?: () => void;
  questionId: string; // Add questionId to force reset between questions
  isPaused?: boolean;
}

export const QuestionTimer = ({ timeLimit, onTimeUp, questionId, isPaused = false }: QuestionTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(timeLimit || null);

  // Reset timer when question changes (using questionId) or timeLimit changes
  useEffect(() => {
    setTimeLeft(timeLimit || null);
  }, [timeLimit, questionId]); // Add questionId to dependencies

  useEffect(() => {
    if (!timeLimit || isPaused) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === null) return null;
        if (prev <= 0) {
          clearInterval(timer);
          onTimeUp?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLimit, onTimeUp, questionId, isPaused]); // Add isPaused to dependencies

  if (!timeLimit) {
    return (
      <Card className="rounded-sm">
        <CardContent className="py-3">
          <p className="text-muted-foreground text-sm">
            No time limit has been set for this question
          </p>
        </CardContent>
      </Card>
    );
  }

  const minutes = Math.floor((timeLeft || 0) / 60);
  const seconds = (timeLeft || 0) % 60;

  return (
    <Card className="rounded-sm">
      <CardContent className="py-3">
        <p className="text-sm">
          Question Time: {minutes}:{seconds.toString().padStart(2, "0")}
        </p>
      </CardContent>
    </Card>
  );
};
